module.exports = __webpack_public_path__ + "img/pc_bg.299d8f9.webp";